var map = {
	"./Article": 30829,
	"./Article/": 30829,
	"./Article/index": 30829,
	"./Article/index.jsx": 30829,
	"./Article/styles.module.css": 50574,
	"./ComparisonLayout": 28132,
	"./ComparisonLayout/": 28132,
	"./ComparisonLayout/index": 28132,
	"./ComparisonLayout/index.jsx": 28132,
	"./ComparisonLayout/left": 74877,
	"./ComparisonLayout/left/": 74877,
	"./ComparisonLayout/left/index": 74877,
	"./ComparisonLayout/left/index.jsx": 74877,
	"./ComparisonLayout/left/styles.module.css": 12798,
	"./ComparisonLayout/second": 40223,
	"./ComparisonLayout/second/": 40223,
	"./ComparisonLayout/second/index": 40223,
	"./ComparisonLayout/second/index.jsx": 40223,
	"./ComparisonLayout/second/styles.module.css": 50975,
	"./ComparisonLayout/styles.module.css": 14577,
	"./EmbedLayout": 20894,
	"./EmbedLayout/": 20894,
	"./EmbedLayout/index": 20894,
	"./EmbedLayout/index.jsx": 20894,
	"./EmbedLayout/styles.module.css": 1713,
	"./FeaturesLayout": 15919,
	"./FeaturesLayout/": 15919,
	"./FeaturesLayout/index": 15919,
	"./FeaturesLayout/index.jsx": 15919,
	"./FeaturesLayout/styles.module.css": 9576,
	"./MenuLayout": 49956,
	"./MenuLayout/": 49956,
	"./MenuLayout/index": 49956,
	"./MenuLayout/index.jsx": 49956,
	"./MenuLayout/styles.module.css": 86857,
	"./MilestonesLayout": 16145,
	"./MilestonesLayout/": 16145,
	"./MilestonesLayout/index": 16145,
	"./MilestonesLayout/index.jsx": 16145,
	"./MilestonesLayout/styles.module.css": 8010,
	"./StoryLayout": 7103,
	"./StoryLayout/": 7103,
	"./StoryLayout/index": 7103,
	"./StoryLayout/index.jsx": 7103,
	"./StoryLayout/styles.module.css": 4921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39077;